<template>
  <b-tag :type="statusColor" size="is-small">{{statusText}}</b-tag>
</template>

<script>
export default {
  props: {
    status: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    statusText () {
      return this.status ? 'Activo' : 'Inactivo'
    },
    statusColor () {
      return this.status ? 'is-info' : 'is-dark'
    }
  }
}
</script>
